import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReconciliationFull2 = _resolveComponent("ReconciliationFull2")!
  const _component_ReconciliationFullClient = _resolveComponent("ReconciliationFullClient")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fill-height",
    style: {"width":"100%"},
    key: _ctx.key
  }, [
    (_ctx.isAccountingUser)
      ? (_openBlock(), _createBlock(_component_ReconciliationFull2, {
          key: 0,
          companyId: _ctx.companyId,
          bankTransactionId: _ctx.bankTransactionId,
          documentId: _ctx.documentId,
          reconciliationId: _ctx.reconciliationId,
          accountingLineId: _ctx.accountingLineId,
          inbeddedMode: _ctx.inbeddedMode,
          mode: _ctx.mode,
          previousIdIsset: _ctx.previousIdIsset,
          nextIdIsset: _ctx.nextIdIsset,
          onPrevious: _ctx.previous,
          onNext: _ctx.next,
          onUpdate: _ctx.update
        }, null, 8, ["companyId", "bankTransactionId", "documentId", "reconciliationId", "accountingLineId", "inbeddedMode", "mode", "previousIdIsset", "nextIdIsset", "onPrevious", "onNext", "onUpdate"]))
      : (_openBlock(), _createBlock(_component_ReconciliationFullClient, {
          key: 1,
          companyId: _ctx.companyId,
          bankTransactionId: _ctx.bankTransactionId,
          documentId: _ctx.documentId,
          reconciliationId: _ctx.reconciliationId,
          accountingLineId: _ctx.accountingLineId,
          mode: _ctx.mode,
          editable: _ctx.isEditable,
          previousIdIsset: _ctx.previousIdIsset,
          nextIdIsset: _ctx.nextIdIsset,
          onPrevious: _ctx.previous,
          onNext: _ctx.next,
          onUpdate: _ctx.update
        }, null, 8, ["companyId", "bankTransactionId", "documentId", "reconciliationId", "accountingLineId", "mode", "editable", "previousIdIsset", "nextIdIsset", "onPrevious", "onNext", "onUpdate"]))
  ]))
}